module.exports = "query getCSVExport($variant:ExportVariant){createExport(variant:$variant)}"